"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._NoncurrentVersionExpiration = {
    type: "structure",
    required: [],
    members: {
        NoncurrentDays: {
            shape: {
                type: "integer"
            }
        }
    }
};
//# sourceMappingURL=_NoncurrentVersionExpiration.js.map